import { createAsyncThunk } from '@reduxjs/toolkit';
import notify from '../../utils/notify';

//Include Both Helper File with needed methods
import {
  getTaskList as getTaskListApi,
  addNewTask as addNewTaskApi,
  updateTask as updateTaskApi,
  deleteTask as deleteTaskApi,
  getTasks as getTasksApi,
  addNewTasks as addNewTasksApi,
  updateTasks as updateTasksApi,
  deleteTasks as deleteTasksApi,
} from '../../helpers/fakebackend_helper';

export const getTaskList = createAsyncThunk('tasks/getTaskList', async () => {
  try {
    const response = getTaskListApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const addNewTask = createAsyncThunk('tasks/addNewTask', async task => {
  try {
    const response = addNewTaskApi(task);
    notify.success('Task added successfully.');
    return response;
  } catch (error) {
    notify.apiError(error, 'add task');
    return error;
  }
});

export const updateTask = createAsyncThunk('tasks/updateTask', async task => {
  try {
    const response = updateTaskApi(task);
    notify.success('Task updated successfully.');
    return response;
  } catch (error) {
    notify.apiError(error, 'update task');
    return error;
  }
});

export const deleteTask = createAsyncThunk('tasks/deleteTask', async task => {
  try {
    const response = deleteTaskApi(task);
    notify.success('Task updated successfully.');
    return { task, ...response };
  } catch (error) {
    notify.apiError(error, 'update task');
    return error;
  }
});

// Kanban Board
export const getTasks = createAsyncThunk('tasks/getTasks', async () => {
  try {
    const response = getTasksApi();
    return response;
  } catch (error) {
    return error;
  }
});
export const addCardData = createAsyncThunk('tasks/addCardData', async card => {
  try {
    const response = addNewTasksApi(card);
    const data = await response;
    notify.success('Card added successfully.');
    return data;
  } catch (error) {
    notify.apiError(error, 'add card');
    return error;
  }
});
export const updateCardData = createAsyncThunk(
  'tasks/updateCardData',
  async card => {
    try {
      const response = updateTasksApi(card);
      const data = await response;
      notify.success('Card updated successfully.');
      return data;
    } catch (error) {
      notify.apiError(error, 'update card');
      return error;
    }
  }
);
export const deleteKanban = createAsyncThunk(
  'tasks/deleteKanban',
  async card => {
    try {
      const response = deleteTasksApi(card);
      notify.success('Card deleted successfully.');
      return response;
    } catch (error) {
      notify.apiError(error, 'delete card');
      return error;
    }
  }
);
